import { useContext } from 'react'
import { ConversionReportContext } from 'contexts/conversion-report/context'

export function useConversionReport() {
  const context = useContext(ConversionReportContext)

  if (context === undefined) {
    throw new Error('useConversionReport must be used within a ConversionReportProvider')
  }

  return context
}
